import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { Tooltip, TooltipTrigger, TooltipContent } from './interactives/Tooltip'

export default function Select({
  label = '',
  tooltip,
  value = '',
  onChange = () => {},
  onBlur = () => {},
  placeholder = 'Enter text...',
  autofocus = false,
  disabled = false,
  required = false,
  loading = false,
  options = [],
  css,
}) {
  return (
    <label
      htmlFor={label}
      className={[
        'py-2 flex flex-col text-blue-500 text-xs',
        disabled && 'bg-transparent',
        loading && 'bg-animated from-gray-900 to-gray-800',
        css,
      ].join(' ')}
    >
      <span className="flex items-center gap-1">
        {label}
        {tooltip && (
          <Tooltip>
            <TooltipTrigger asChild>
              <FontAwesomeIcon
                icon={faInfoCircle}
                className="text-blue-500/50"
              />
            </TooltipTrigger>
            <TooltipContent>{tooltip}</TooltipContent>
          </Tooltip>
        )}
      </span>
      <select
        id={label}
        disabled={disabled}
        autoFocus={autofocus}
        required={required}
        className="h-9 mt-1 px-3 py-1 text-base focus:outline-hidden focus:ring-3 text-white bg-gray-800 rounded-sm"
        value={value}
        placeholder={placeholder}
        onChange={(e) => {
          onChange(e.target.value)
        }}
        onBlur={onBlur}
      >
        {options.map((op, i) => {
          return (
            <option
              key={i}
              value={op.value}
            >
              {op.name}
            </option>
          )
        })}
      </select>
    </label>
  )
}

Select.propTypes = {
  label: PropTypes.string,
  tooltip: PropTypes.node,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  autofocus: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  loading: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  css: PropTypes.string,
}
